import { render } from "./userDetail.vue?vue&type=template&id=53d91f56&scoped=true"
import script from "./userDetail.vue?vue&type=script&lang=js"
export * from "./userDetail.vue?vue&type=script&lang=js"

import "./userDetail.vue?vue&type=style&index=0&id=53d91f56&lang=scss"
import "./userDetail.vue?vue&type=style&index=1&id=53d91f56&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d91f56"],['__file',"src/views/userCenter/tagEdit/components/userDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53d91f56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53d91f56', __exports__)) {
    console.log('reload')
    api.reload('53d91f56', __exports__)
  }
  
  module.hot.accept("./userDetail.vue?vue&type=template&id=53d91f56&scoped=true", () => {
    console.log('re-render')
    api.rerender('53d91f56', render)
  })

}


export default __exports__